import React, { useState } from 'react';

const Home = () => {
  return (
    <div className='home'>
      <h2>
      VÄLKOMMEN TILLL HALDORS INFORMATIONS APP
      </h2>
    </div>
  )
};

export default Home;
